// MenuToggle.tsx - VERSIÓN COMPATIBLE
import * as React from "react";

export const MenuToggle = ({ toggle, isOpen }) => (
  <button 
    onClick={toggle}
    style={{
      position: 'absolute',
      top: '18px',
      left: '15px',
      width: '50px',
      height: '50px',
      borderRadius: '50%',
      border: 'none',
      outline: 'none',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 60,
      background: isOpen 
        ? '#ffffff' 
        : 'linear-gradient(135deg, #7c3aed, #4f46e5)',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
    }}
    aria-label={isOpen ? "Cerrar menú" : "Abrir menú"}
  >
    {isOpen ? (
      // Icono de "X" cuando está abierto
      <div style={{ position: 'relative', width: '20px', height: '20px' }}>
        <span
          style={{
            position: 'absolute',
            left: 0,
            top: '9px',
            width: '20px',
            height: '2px',
            backgroundColor: '#4f46e5',
            borderRadius: '1px',
            transform: 'rotate(45deg)'
          }}
        />
        <span
          style={{
            position: 'absolute',
            left: 0,
            top: '9px',
            width: '20px',
            height: '2px',
            backgroundColor: '#4f46e5',
            borderRadius: '1px',
            transform: 'rotate(-45deg)'
          }}
        />
      </div>
    ) : (
      // Logo de libro cuando está cerrado
      <div style={{ 
        width: '24px', 
        height: '24px',
        color: 'white'
      }}>
        <svg 
          width="24" 
          height="24" 
          viewBox="0 0 24 24" 
          fill="none"
        >
          <path 
            d="M12 21C12 21 5 16 5 10V5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V10C19 16 12 21 12 21Z" 
            stroke="currentColor" 
            strokeWidth="1.5" 
            fill="currentColor" 
            fillOpacity="0.2"
          />
          <path 
            d="M9 8H15M9 12H13" 
            stroke="currentColor" 
            strokeWidth="1.5" 
            strokeLinecap="round"
          />
        </svg>
      </div>
    )}
  </button>
);